import "./ContactMe.css";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";

const ContactMe = () => {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_cqvu6ha",
        "template_hfdwohc",
        e.target,
        "user_z2Tqm9kueAdtrwvlsw1YV"
      )
      .then(
        (result) => {
          console.log(result.text);
          if (result.text) {
            Swal.fire("Good job!", "Message send successfully...!");
          } else {
            alert("Try again");
          }
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <>
      <div className="row contact-me py-5 ">
        <div className="col-lg-12 col-md-12 col-12 mx-auto booking-right">
          <div className="order-box mt-5  pb-3  d-flex justify-content-center align-items-center">
            <div className="booking-form pb-5  py-3">
              <p className="fs-2 text-center mt-4 pe-lg-4 fw-bold text-black">
                Contact 
              </p>
              <p className="text-black fw-bold fs-6"> Have a question or want to work together?</p>
              <form onSubmit={sendEmail}>
                <input
                  placeholder="Name"
                  type="text"
                  className="p-2  text-white my-2"
                  name="name"
                />
                <br />
                <input
                  placeholder="Email"
                  name="email"
                  type="email"
                  className="p-2 text-white my-2"
                />

                <br />
                <input
                  placeholder="Subject"
                  name="subject"
                  type="text"
                  className="p-2 text-white my-2"
                />

                <br />
                <textarea
                  className="p-2 my-2 rounded-3 bg-black w-100 text-secondary"
                  placeholder="What You Want to Say?"
                  name="message"
                />
                <br />
                <input
                  className="  px-3 mt-3 submit-btn bg-black  fs-6   btn "
                  value="Send message"
                  type="submit"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactMe;
